import { FC, useEffect, useMemo, useRef, useState } from "react"
import { PluginWrapper, ToolbarWrapper } from "../../../components/plugins"
import { v4 as uuidv4 } from 'uuid';
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter";
import UISettingsPluginSettings from "./UISettingsPluginSettings";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { SysOptionsCommandPanel } from "../SysOptions/components/SysOptionsCommandPanel";
import { DocumentGridStateType } from "../../../@types/documents";
import { Spinner } from "../../../components/spiner/Spinner";
import { LoadingStatus } from "../../../@types/enumsGlobal";
import { UISettingsEditModal } from "./components/UISettingsEditModal";

interface IUISettingsViewDTO {
    idGlobal: string;
    displayName: string;
    settingsName: string;
    description: string;
}

export const UISettingsPluginView: FC<IGridProps> = (props) => {

    const [gridFilter, dispatchGridFilter] = useGridFilter(CreateSelectorGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [editModal, setEditModal] = useState<boolean>(false);
    const [viewState, setViewState] = useState<DocumentGridStateType>("view");
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [data, setData] = useState<IUISettingsViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [loadingStatus, setLoadingStatus] = useState(LoadingStatus.InProcess);

    const isRealRefresh = useRef(false);

    const handleRefresh = () => {
        setSelectedItem(undefined);
        isRealRefresh.current = true;
        setViewState('refresh');
    };

    const settings: IUISettingsViewDTO[] = [
        {
            idGlobal: "bf75c156-ac53-4b02-a934-24af2d468e1e",
            displayName: "Шрифт в таблицах",
            settingsName: "gridFont",
            description: "Изменение шрифта в таблицах документов, справочников "
        },
        {
            idGlobal: "fb18a776-ee20-4efc-a534-108b2620571c",
            displayName: "Приходная накладная",
            settingsName: "invoiceItemCreator",
            description: "Настройки табуляции в окне создания позиций ПН, другие настройки ПН"
        },
        {
            idGlobal: "2c9e4a81-7b3d-4f62-9a15-6d8e0c1b4f27",
            displayName: "Размер модальных окон",
            settingsName: "modalSize",
            description: "Настройка размера модальных окон по умолчанию"
        },
    ];

    const loadData = () => {
        setIsSubmitting(true);
        setData(settings);
        setTotalCount(settings.length);
        setLoadingStatus(LoadingStatus.Completed);
        setViewState('view');
        setIsSubmitting(false);
    }

    useEffect(() => {
        loadData()
    }, [])

    useEffect(() => {
        if (viewState === 'refresh') {
            setViewState('view');
            return
        }
        loadData();
    }, [viewState, gridFilter])

    const selectedSettingsName = useMemo(() => {
        if (!selectedItem) return undefined;
        return data.find(s => s.idGlobal === selectedItem.idGlobal)?.settingsName;
    }, [data, selectedItem]);

    return (
        <PluginWrapper>
            <ToolbarWrapper>
                <SysOptionsCommandPanel
                    edit={{
                        disabled: !selectedItem,
                        onClick: () => {
                            setEditModal(true)
                        }
                    }}
                    refresh={{
                        onClick: handleRefresh
                    }}

                    permission={props.plugin.permission}
                />
            </ToolbarWrapper>
            {isSubmitting ?
                <Spinner />
                :
                <DefaultGrid
                    showQuantity
                    gridId={uuidv4()}
                    data={data}
                    loadingStatus={loadingStatus}
                    totalCount={totalCount}
                    filter={gridFilter}
                    plugin={UISettingsPluginSettings}
                    selectedItem={selectedItem}
                    onSelect={(row) => {
                        setSelectedItem(row)
                    }}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                />
            }
            {
                editModal &&
                <UISettingsEditModal
                    settingsName={selectedSettingsName}
                    cancel={() => {
                        setEditModal(false)
                        isRealRefresh.current = true;
                        setViewState('refresh')
                        setSelectedItem(undefined)
                    }}
                />
            }
        </PluginWrapper>
    )
}
